<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <main-toolbar></main-toolbar>
    <DialogStatus ref="dlgStatus"></DialogStatus>
    <v-container>
    <v-layout justify-center class="hidden-sm-and-down" v-if="!isLoading">
        <v-layout class="row justify-content-center" v-if="hasError">
          {{errorText}}
        </v-layout>
    </v-layout>
    <v-layout align-center justify-center row fill-height class="mt-5">
      <v-flex xs11 sm11 md10>
        <v-card max-height="800px" min-height="800px" flat color="transparent">
        <v-tabs
          v-model="active"
          color="rgba(255, 255, 255, 0.5)"
          @change="onChangeTab"
          slider-color="#6274af"
        >
          <v-tab
            dark
            key="0"
            class="text-none"
            v-if="!isCloud"
          >
            Allgemein
          </v-tab>
          <v-tab v-if="false"
            key="1"
            dark
            class="text-none"
          >
            Dokument Management System
          </v-tab>
          <v-tab
            key="2"
            dark
            class="text-none"
          >
            Lizenz
          </v-tab>
          <v-tab-item
            key="0"
            v-if="!isCloud"
          >
            <v-card
            flat
            class="pa-3"
            >
              <div class="title text-left mb-3">Server Einstellungen</div>
              <v-form v-model="valid" @submit="onSubmit" @reset="onReset">
                <v-layout row wrap justify-center class="pa-3">
                  <v-flex xs12 sm5>
                    <v-card flat>
                      <div class="title text-left font-weight-light mb-3">Allgemein</div>
                      <v-layout row>
                        <v-flex md3>
                        </v-flex>
                        <v-flex md6 class="pa-2 bordernone pt-0 mb-3">
                          <v-text-field v-model="scannerConfig.name" label="SAS Name" required
                                        @change="doWarn=true"
                                        defaut="8000" class="textblock pt-4 px-3 mt-0" color="#6274af"></v-text-field>
                        </v-flex>
                      </v-layout>
                      <div class="title text-left font-weight-light mb-3">Serverprotkoll</div>
                      <v-layout row class="justify-space-around">
                        <v-flex xs2 md3 class="ml-5">
                          <v-checkbox class="checkbox-custom checkbox-inline" data-initialize="checkbox"
                                      v-model="scannerConfig.ssl"
                                      @change="doWarn=true"
                                      label="SSL"
                                      color="#6274af">
                          </v-checkbox>
                        </v-flex>
                          <v-flex xs8 md6 class="pa-2 bordernone pt-0 mb-3">
                          <v-text-field v-model="scannerConfig.port" label="Port Https" required
                                        @change="doWarn=true"
                                        defaut="8000" class="textblock pt-4 px-3 mt-0" color="#6274af"></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row class="justify-space-around">
                        <v-flex xs2 md3 class="ml-5">
                          <v-checkbox class="checkbox-custom checkbox-inline" data-initialize="checkbox"
                                      v-model="scannerConfig.http"
                                      @change="doWarn=true"
                                      label="HTTP" color="#6274af"></v-checkbox>
                        </v-flex>
                        <v-flex xs8 md6 class="pa-2 bordernone pt-0 mb-3">
                          <v-text-field v-model="scannerConfig.httpPort" label="Port Http" required
                                        @change="doWarn=true"
                                        defaut="8001" class="textblock pt-4 px-3 mt-0" color="#6274af"></v-text-field>
                        </v-flex>
                      </v-layout>

                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm5>
                  <v-card flat>
                    <div class="title text-left font-weight-light mb-3">HostNames</div>
                    <v-list>
                      <template v-for="(item) in hostNames">
                        <v-list-tile @click="open(item)" :key="item">
                          <v-icon>link</v-icon>
                          {{item}}
                        </v-list-tile>
                      </template>
                    </v-list>
                    <v-flex md4>
                      <v-card flat>

                      </v-card>
                    </v-flex>
                  </v-card>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <div>
                    <v-alert
                      :value="true"
                      v-if="doWarn"
                      type="warning"
                    >
                      Diese Einstellungen werden erst nach dem Neustart der Anwendung wirksam!
                    </v-alert>
                  </div>
                </v-layout>
                <div class="title text-left mb-3">Scanner Konfiguration</div>

                <v-layout row class="pa-3 justify-center">
                  <v-flex xs12 sm3>
                    <v-checkbox v-model="scannerConfig.supportTwain" label="Twain Unterstützung" color="#6274af"></v-checkbox>
                  </v-flex>
                </v-layout>
                <v-layout v-if="!isCloud">
                  <v-container>
                    <v-layout align-center justify-space-between row>
                      <v-flex md4 class="pa-2 bordernone pt-0 mb-3">
                        <v-card flat>
                        <v-select
                          :items="scannerList"
                          v-model="currentScanner"
                          item-text="name"
                          item-value="id"
                          return-object
                          label="Scanner"
                          class="textblock pt-4 px-3 mt-0" color="#6274af">
                        </v-select>
                        </v-card>
                      </v-flex>
                      <v-flex md2 class="pa-2 bordernone pt-0 mb-3">
                        <v-card flat>
                        <v-select
                          :items="resolutions"
                          v-model="scannerConfig.resolution"
                          item-text="title"
                          item-value="guid"
                          return-object
                          label="Auflösung"
                          class="textblock pt-4 px-3 mt-0" color="#6274af">
                        </v-select>
                        </v-card>
                      </v-flex>
                      <v-flex md4 class="pa-2 bordernone pt-0 mb-3">
                        <v-card flat>
                        <v-select
                          :items="colors"
                          v-model="scannerConfig.mode"
                          item-text="text"
                          item-value="value"
                          label="Farben"
                          class="textblock pt-4 px-3 mt-0" color="#6274af">
                        </v-select>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-layout>
              </v-form>
              <v-layout row justify-center class="pa-3">
                <v-flex xs12>
                <v-btn color="#6f6f6e" large block outline  class="text-none font-weight-bold mb-5" type="button" @click="saveLic">Speichern</v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-tab-item>
          <v-tab-item v-if="false"
            key="1"
          >
            <v-card
              flat
              class="pa-3"
            >
              <div class="title text-left mb-3" v-if="!isCloud">Allgemein</div>
              <CategoryDialog ref="newDialog"></CategoryDialog>
              <NewStatusDialog ref="newStatusDialog" @itemAdded="reloadStatus"></NewStatusDialog>

              <v-layout row wrap class="mx-3" v-if="!isCloud">
                <v-flex xs11 sm11 md5>
                  <v-card tile flat color="transparent">
                    <v-checkbox class="checkbox-custom checkbox-inline" v-model="scannerConfig.hasDocumentStorage"
                                label="Dokument Speicherung" color="#6274af"></v-checkbox>
                  </v-card>
                </v-flex>
                <v-flex xs12 v-if="scannerConfig.hasDocumentStorage" class="pa-2 bordernone pt-0 mb-3">
                  <v-card tile flat color="transparent">
                    <v-text-field v-model="scannerConfig.downloadFolder"
                                  label="Ordner worin Ihre Dokumente gespeichert werden" class="textblock pt-4 px-3 mt-0" color="#6274af"></v-text-field>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-layout row justify-center class="mb-3 pa-2 mx-3" v-if="!isCloud">
                <v-flex xs12>
                <v-btn color="#6f6f6e" large block outline  class="text-none font-weight-bold mb-5" type="button" @click="onSubmit">Speichern</v-btn>
                </v-flex>
              </v-layout>
              <div v-if="!isCloud && scannerConfig.hasDocumentStorage && dmsStatus" class="title text-left mb-3">OCR Erkennung</div>
              <v-layout row justify-center v-if="!isCloud && scannerConfig.hasDocumentStorage" class="mb-3 pa-2 mx-3">
                <v-flex xs12 class="text-left">
                  <v-card tile flat color="transparent">
                    <v-flex xs12 v-if="missingLizenz">
                      <v-card>
                        <v-card-text class="missingLizenz pa-3 subheading">
                          <v-icon color="orange">warning</v-icon>
                          In der Demo Version kann die automatische OCR Erkennung nicht aktiviert werden.
                          <v-icon color="orange">warning</v-icon>
                        </v-card-text>
                      </v-card>
                    </v-flex>

                    <v-checkbox :disabled="missingLizenz" class="checkbox-custom checkbox-inline" v-model="scannerConfig.autoOCROnPDFImages"
                                label="Automatische OCR Erkenung" color="#6274af"></v-checkbox>
                    <span>PDF Dateien die nur ein Bild enthalten können automatisch mittels unserem OCR Service anonym in der Cloud in Text gewandelt werden.
                    Hierbei wird ein Bild aus dem PDF Dokument erstellt und dem Service übermittelt. Alle Daten werden direkt im Anschluss wieder gelöscht.</span>
                    <br><br>
                  </v-card>
                </v-flex>
              </v-layout>
              <div v-if="!isCloud && scannerConfig.hasDocumentStorage && dmsStatus" class="title text-left mb-3">E-Mail versand</div>
              <v-layout row justify-center v-if="!isCloud && scannerConfig.hasDocumentStorage" class="mb-3 pa-2 mx-3">
                  <v-checkbox v-model="scannerConfig.supportEmail" label="E-Mail aktivieren" color="#6274af"></v-checkbox>
              </v-layout>
              <v-layout row justify-center v-if="scannerConfig.hasDocumentStorage && scannerConfig.supportEmail" class="mb-3 pa-2 mx-3">
                <v-flex xs12 class="pa-2 bordernone pt-0 mb-3">
                  <v-card tile flat color="transparent">
                    <v-text-field v-model="scannerConfig.mailFromAddress"
                                  clearable
                                  label="Ihre E-Mail Sender - Adresse" class="textblock pt-4 px-3 mt-0" color="#6274af"></v-text-field>
                  </v-card>
                </v-flex>
              </v-layout>

              <div v-if="scannerConfig.hasDocumentStorage && dmsStatus" class="title text-left mb-3">DMS Statistik</div>
              <v-layout row justify-center v-if="scannerConfig.hasDocumentStorage && dmsStatus">
                <v-flex xs10 class="text-left">
                  <span>Anzahl Dateien {{dmsStatus.fileCnt}}</span><br>
                  <span>Anzahl Kategorien {{dmsStatus.categoryFileCnt}}</span><br>
                  <br>
                </v-flex>
              </v-layout>
              <!-- Dokument Kategorieren -->
              <div class="title text-left mb-3">Dokument Kategorien</div>
              <v-layout row wrap v-if="scannerConfig.hasDocumentStorage">
                <v-flex md12 class="pa-3">
                  <v-data-table
                    :headers="headers"
                    :items="categories"
                    hide-actions
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td class="text-xs-left">{{ props.item.title }}</td>
                      <td class="text-xs-left">{{ props.item.used }}</td>
                      <td class="text-xs-left">
                        <span v-for="(field, i) in props.item.extraFields" v-bind:key="i">{{field.name}}, </span></td>
                      <td class="justify-center layout px-0">
                        <v-icon
                          small
                          class="pr-2"
                          @click="editExtraFields(props.item)"
                        >
                          edit
                        </v-icon>
                        <v-icon
                          small
                          @click="deleteItem(props.item)"
                        >
                          delete
                        </v-icon>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <v-layout row justify-center v-if="scannerConfig.hasDocumentStorage" class="mb-3 pa-2">
                <v-flex xs12 v-if="missingLizenz && categories.length >= 3" class="mx-2">
                  <v-card class="mb-3">
                    <v-card-text class="missingLizenz pa-3 subheading">
                      <v-icon color="orange">warning</v-icon>
                      In der Demo Version können nur bis zu 3 Kategorien hinzugefügt werden
                      <v-icon color="orange">warning</v-icon>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 class="mx-2">
                <v-btn color="#6f6f6e" :disabled="missingLizenz && categories.length >= 3" large block outline  class="text-none font-weight-bold mb-5" type="button" @click="newItem">Kategorie hinzufügen</v-btn>
                </v-flex>
              </v-layout>
              <!-- Dokument Kategorieren ende -->
              <!-- Dokument Status -->
              <div class="title text-left mb-3">Dokument Status</div>
              <v-layout row wrap v-if="scannerConfig.hasDocumentStorage">
                <v-flex md12 class="pa-3">
                  <v-data-table
                    :headers="statusHeaders"
                    :items="statusList"
                    hide-actions
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td class="text-xs-left">{{ props.item.title }}</td>
                      <td class="text-xs-left">{{ props.item.used }}</td>
                      <td class="text-xs-left">
                        <span v-for="(field, i) in props.item.extraFields" v-bind:key="i">{{field.name}}, </span></td>
                      <td class="justify-center layout px-0">
                        <v-icon
                          small
                          class="pr-2"
                          @click="editStatus(props.item)"
                        >
                          edit
                        </v-icon>
                        <v-icon
                          small
                          @click="deleteItemStatus(props.item)"
                        >
                          delete
                        </v-icon>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <v-layout row justify-center v-if="scannerConfig.hasDocumentStorage" class="mb-3 pa-2">

                <v-flex xs12 v-if="missingLizenz && statusList.length >= 3" class="mx-2">
                  <v-card class="mb-3">
                    <v-card-text class="missingLizenz pa-3 subheading">
                      <v-icon color="orange">warning</v-icon>
                      In der Demo Version können nur bis zu 3 Stati hinzugefügt werden
                      <v-icon color="orange">warning</v-icon>
                    </v-card-text>
                  </v-card>
                </v-flex>

                <v-flex xs12 class="mx-2">
                  <v-btn color="#6f6f6e" :disabled="missingLizenz && statusList.length >= 3" large block outline  class="text-none font-weight-bold mb-5" type="button" @click="newStatusItem">Status hinzufügen</v-btn>
                </v-flex>
              </v-layout>
              <!-- Dokument Status ende-->

              <div v-if="scannerConfig.hasDocumentStorage && sasClients && sasClients.length > 0" class="subheading text-left font-weight-light mb-3 textblue">Weitere SAS Clients gefunden</div>
              <v-layout row wrap v-if="scannerConfig.hasDocumentStorage && sasClients && sasClients.length > 0">
                <v-flex md12 class="pa-3">
                  <v-data-table
                    :headers="headers"
                    :items="sasClients"
                    hide-actions
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td class="text-xs-left">{{ props.item.host }}</td>
                      <td class="text-xs-left">{{ props.item.config.name }}</td>
                      <td class="justify-center layout px-0">
                        <v-icon
                          small
                          @click="editConfig(props.item)"
                        >
                          edit
                        </v-icon>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card>
          </v-tab-item>
          <v-tab-item
            key="2"
            v-if="true"
            width="100%"
          >
            <v-card
              flat
              class="mt-5"
            >

            <v-layout row justify-space-around>
                <v-flex md8>
                  <v-text-field readonly v-model="scannerConfig.licenseOwner" label="Lizenz Benutzer"></v-text-field>
                </v-flex>
                <v-flex md8>
                  <v-text-field clearable v-model="scannerConfig.license" label="Lizenz Schlüssel"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout v-if="scannerConfig.licenseValid" justify-start>
                <v-flex>
                  Sie haben eine gültige Lizenz erworben. Vielen Dank.
                  <br><br>
                </v-flex>
              </v-layout>
              <v-layout v-if="!scannerConfig.licenseValid" justify-start>
                <v-flex class="text-xs-left pa-4">
                  Sie arbeiten mit der Demo Lizenz. Sie können eine Lizenz erwerben.
                  <span>Kontaktieren Sie die edologic GmbH. <a href="https://www.edologic.de">https://www.edologic.de</a></span>
                  <br><br><br>

                  <span v-if="false && !hostOk">
                    <br>
                    Das erwerben per Paypal ist nur über die Webseite <a href="https://localhost.surfandscan.com:8000">https://localhost.surfandscan.com:8000</a> möglich.
                    <br>
                    Sie nutzen aktuell die Webseite: {{buyerHost}}
                  </span>
                  <br><br>
                </v-flex>
              </v-layout>
              <v-layout justify-center v-if="!scannerConfig.licenseValid">
                <span class="shopText" v-if="false">
                  Sie können das Produkt hier online erwerben und direkt loslegen.
                  Klicken Sie hier auf dem PayPal Button und erwerben Sie das Produkt "SurfAndScan Premium" für 49 € inkl. MwSt.
                  Sie erhalten umgehend den Lizenz Schlüssel.
                  <br><br>
                  Der Verkäufer lautet:<br><br>
                  edologic GmbH<br>
                  In der Hardt 3<br>
                  42399 Wuppertal<br>
                  Deutschland (Germany)
                  <br><br>
                  Das Produkt "SurfAndScan Premium" wird für dieses Endgerät lizensiert und kann dort genutzt werden.
                </span>
                <span class="shopText" v-if="false">
                  Sie können das Produkt auch hier online erwerben und direkt loslegen.
                  Klicken Sie hier auf dem PayPal Button und erwerben Sie das Produkt "woohoo Premium" für 49 € inkl. MwSt.
                  Sie erhalten umgehend den Lizenz Schlüssel für eine Laufzeit von 12 Monaten.
                  <br><br>
                  Der Verkäufer lautet:<br><br>
                  edologic GmbH<br>
                  In der Hardt 3<br>
                  42399 Wuppertal<br>
                  Deutschland (Germany)
                  <br><br>
                  Das Produkt "woohoo Premium" wird für diesen Account lizensiert.
                </span>
                <div id="paypal-button-container"></div>
              </v-layout>
              <v-layout row justify-center v-if="!scannerConfig.licenseValid">
                <v-flex xs6 class="pa-3">
                  <v-btn color="#6f6f6e" large block outline  class="text-none font-weight-bold mb-5" type="button" @click="onSubmit">Speichern</v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-tab-item>
        </v-tabs>
        </v-card>
      </v-flex>
      </v-layout>
      <DialogConfigExtraFields ref="configExtraFields" @onSave="doSaveExtraFields"></DialogConfigExtraFields>
      <DialogConfigStatus ref="configStatus" @onSave="doSaveStatus"></DialogConfigStatus>
    </v-container>
  </div>
</template>

<script>
import DialogConfigExtraFields from './dialogs/DialogConfigExtraFields'
import DialogConfigStatus from './dialogs/DialogConfigStatus'
import Vue from 'vue'
import MainToolbar from './toolbar/MainToolbar'
import CategoryDialog from './pages/dialogs/NewCategoryDialog.vue'
import sas from 'surfandscan'
import NewStatusDialog from './pages/dialogs/NewStatusDialog'
import axios from 'axios'
import DialogStatus from './dialogs/DialogStatus'

export default {
  components: {DialogStatus, DialogConfigStatus, NewStatusDialog, CategoryDialog, MainToolbar, DialogConfigExtraFields},
  name: 'Configuration',
  data () {
    return {
      isCloud: Vue.prototype.$config.isCloud,
      sasIsActive: false,
      doWarn: false,
      dmsStatus: null,
      valid: true,
      isLoading: false,
      buyerHost: 'local',
      systemConfig: {},
      hostOk: false,
      hostNames: [],
      scanner: null,
      sasClients: [],
      hasError: false,
      active: null,
      text: 'hier kommt ein Blindtext',
      statusList: [],
      statusHeaders: [
        {
          text: 'Statusname',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Felds',
          align: 'left',
          sortable: false,
          value: 'fields'
        },
        {
          text: 'Verwendet',
          align: 'left',
          sortable: false,
          value: 'used'
        },
        {text: 'Aktion', value: 'action'}
      ],
      headers: [
        {
          text: 'Kategoriename',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Felds',
          align: 'left',
          sortable: false,
          value: 'fields'
        },
        {
          text: 'Verwendet',
          align: 'left',
          sortable: false,
          value: 'used'
        },
        {text: 'Aktion', value: 'action'}
      ],
      errorText: '',
      currentScanner: null,
      scannerConfig: {},
      missingLizenz: false,
      scannerList: [],
      categories: [],
      resolutions: [200, 300, 600, 1200],
      colors: [{
        text: '8 Bit Graustufen',
        value: 'GRAY_8'
      }, {
        text: '12 Bit Graustufen',
        value: 'GRAY_16'
      }, {
        text: '8 Bit',
        value: 'RGB_8'
      }, {
        text: '16 Bit',
        value: 'RGB_16'
      },
      {
        text: '32 Bit',
        value: 'RGB_32'
      }]
    }
  },
  methods: {
    onLicSaved (data) {
      console.log('onLicSaved', data)
      this.isLoading = false
      Vue.prototype.$eventHub.$emit('OnReloadConfig', false)
      sas.getConfig(this.onGetConfig)
    },
    onConfigSet (data) {
      console.log('onConfigSet', data)
      this.isLoading = false
      Vue.prototype.$eventHub.$emit('OnReloadConfig', false)
      sas.getConfig(this.onGetConfig)
    },
    next () {
      const active = parseInt(this.active)
      this.active = (active < 2 ? active + 1 : 0)
    },
    newItem () {
      this.$refs.newDialog.open()
    },
    newStatusItem () {
      this.$refs.newStatusDialog.open()
    },
    doSaveExtraFields (item) {
      console.log('doSaveExtraFields', item)
      // Vue.prototype.$dms.updateStorageCategory(item.item.guid, JSON.stringify(item.extraFields), item.categorySelectWord, this.onCategoryUpdated)
    },
    doSaveStatus (item) {
      console.log('doSaveStatus', item)
      // Vue.prototype.$dms.updateStorageItemStatus(item.item.guid, item.item, this.onStatusUpdated)
    },
    onCategoryUpdated (res) {
      console.log('onCategoryUpdated', res)
      // Vue.prototype.$dms.getStorageCategories(this.onGetCategories)
      // Vue.prototype.$storage.loadCategories(null)
    },
    onStatusUpdated (res) {
      // Vue.prototype.$dms.getStorageStatus(this.onGetStatus)
      // Vue.prototype.$storage.loadStatus(null)
    },
    saveLic () {
      console.log('onSubmit', this.scannerConfig)
      this.isLoading = true
      // sas.getConfig(this.onSASGetConfig)
      sas.setConfig(this.scannerConfig, this.onLicSaved, this.onError)
      return false
    },
    onSubmit () {
      console.log('onSubmit', this.scannerConfig)
      this.isLoading = true
      // sas.getConfig(this.onSASGetConfig)
      sas.setConfig(this.scannerConfig, this.onConfigSet, this.onError)
      return false
    },
    deleteItemStatus (status) {
      console.log('deleteItemStatus', status)
      // Vue.prototype.$dms.deleteStorageStatus(status.guid, this.onGetStatus)
    },
    deleteItem (item) {
      console.log('deleteItem', item)
      // Vue.prototype.$dms.deleteStorageCategory(item.guid, this.onGetCategories)
    },
    editConfig (item) {
      let url = ''
      if (item.config.http) {
        url += 'http://' + item.host + ':' + item.config.httpPort + '/index.html/#/Configuration'
      }
      console.log('editConfig', item, url)
      window.open(url, '_new')
    },
    editExtraFields (item) {
      let d = JSON.parse(JSON.stringify(item))
      this.$refs['configExtraFields'].open(d)
    },
    editStatus (item) {
      let d = JSON.parse(JSON.stringify(item))
      this.$refs['configStatus'].open(d)
    },
    onReset () {
    },
    setCurrentScanner () {
      this.scannerConfig.deviceName = this.currentScanner.name
      this.scannerConfig.deviceAddress = this.currentScanner.id
    },
    getCurrentScannerName () {
      if (this.currentScanner) {
        return this.currentScanner.deviceName
      }
    },
    onGetDMSStatus (status) {
      console.log('onGetDMSStatus', status)
      this.dmsStatus = status
    },
    onGetClients (clients) {
      if (clients && clients.list) {
        try {
          for (let i = 0; i < clients.list.length; i++) {
            var client = clients.list[i]
            client.config = JSON.parse(client.config)
          }
        } catch (err) {
          console.error(err)
        }

        this.sasClients = clients.list
      } else {
        this.sasClients = []
      }
    },
    onSASGetConfig (config) {
      console.log('onSASGetConfig', config)
      this.scannerConfig = config
      // this.scannerConfig.licenseValid = false
      this.hostNames = []
      for (let i = 0; i < config.hostNames.length; i++) {
        var unit = config.hostNames[i]
        if (this.scannerConfig.http) {
          this.hostNames.push('http://' + unit)
        }
        if (this.scannerConfig.ssl) {
          this.hostNames.push('https://' + unit)
        }
      }
      this.missingLizenz = !config.licenseValid
      sas.getDevices(this.onGetDevices, this.onError)
    },
    onGetConfig (config) {
      console.log('onGetConfig', config)
      this.scannerConfig = config
      this.missingLizenz = !config.licenseValid
    },
    onGetCategories: function (data) {
      console.log('onGetCategories', data)
      this.categories = data.categories
      for (var i in data.categories) {
        var cat = data.categories[i]
        try {
          cat.extraFields = JSON.parse(cat.extraFields)
        } catch (e) {
          console.log(e)
        }
      }
    },
    onGetStatus: function (data) {
      console.log('onGetStatus', data)
      this.statusList = data.status
      Vue.prototype.$eventHub.$emit('reloadConfig', true)
    },
    onGetDevices (devices) {
      console.log('devices', devices)
      this.scannerList = devices
      this.isLoading = false
      this.markCurrentScanner()
    },
    markCurrentScanner () {
      for (let i = 0; i < this.scannerList.length; i++) {
        var unit = this.scannerList[i]
        if (this.scannerConfig.deviceAddress === unit.id) {
          this.currentScanner = unit
        }
      }
    },
    reloadStatus () {
      console.log('reloadStatus')
      //  Vue.prototype.$storage.loadStatus(this.onGetStatus)
    },
    onError (error, var1, var2) {
      console.log('onError', error, var1, var2)
      this.isLoading = false
      this.hasError = true
      this.errorText = JSON.stringify(error)
    },
    forwardPost (details) {
      let url = Vue.prototype.$dms.gbl_host + '/dms'
      let params = {
        time: new Date().getTime()
      }
      let cmp = this
      var reqData = details
      axios({
        method: 'post',
        data: JSON.stringify(reqData),
        params: params,
        url: url,
        responseType: 'json'
      })
        .then(function (response) {
          cmp.onSuccessPaypal(response.data)
        }, function (error) {
          Vue.prototype.$eventHub.$emit('OnShowError', error)
          console.error('error')
          console.error(error)
          console.log(status)
        })
    },
    onSuccessPaypal (d) {
      console.log('onSuccessPaypal', d)
      if (d.ok) {
        d.messageTitle = 'Einkauf war erfolgreich. Vielen Dank.'
        d.success = true
      } else {
        d.messageTitle = 'Einkauf fehlgeschlagen. Bitte wenden Sie sich an den Support. (support@edologic.de) ' + d.message
        d.success = false
      }
      Vue.prototype.$eventHub.$emit('OnReloadConfig', false)
      this.$refs.dlgStatus.open(d)
    },
    open (item) {
      var url = ''
      url = url + item + ':' + this.scannerConfig.port + '/index.html'
      window.open(url, '_new')
    },
    onGetFailed (d) {
      console.log('onGetFailed sas not found on local device', d)
      this.sasIsActive = false
    },
    sasIsAvailable: function (d) {
      console.log('sasIsAvailable', d)
      this.sasIsActive = true
      sas.getConfig(this.onSASGetConfig)
    },
    onChangeTab: function (tab) {
      console.log('onChangeTab', tab)
      if ((this.isCloud && '' + tab === '1') || (!this.isCloud && '' + tab === '2')) {
        if (this.scannerConfig && !this.scannerConfig.licenseValid) {
          window.paypal.Buttons({
            // Set up the transaction
            createOrder: function (data, actions) {
              let rid = window.sasComponent.scannerConfig.licenseOwner
              let order = actions.order.create({
                purchase_units: [{
                  shipping_method: 'online',
                  'reference_id': rid,
                  'description': 'woohoo Premium Version id:' + rid + ' (Laufzeit 12 Monate)',
                  'custom': '' + rid,
                  'payment_descriptor': '' + rid,
                  'amount': {
                    'currency': 'EUR',
                    value: '49.00'
                  }
                }]
              })
              return order
            },
            // Finalize the transaction
            onApprove: function (data, actions) {
              return actions.order.capture().then(function (details) {
                window.sasComponent.forwardPost(details)
              })
            }
          }).render('#paypal-button-container')
        }
      }
    }
  },
  created () {
    Vue.prototype.$eventHub.$on('newCategoryAdded', this.onGetCategories)
  },
  destroyed () {
    Vue.prototype.$eventHub.$off('newCategoryAdded', this.onGetCategories)
  },
  mounted () {
    this.isLoading = true
    this.isCloud = Vue.prototype.$config.isCloud
    this.systemConfig = Vue.prototype.$config
    this.buyerHost = window.location.protocol + '' + window.location.host
    this.hostOk = this.buyerHost === 'https://localhost.surfandscan.com:8000/index.html'
    // Vue.prototype.scanApi.updateUrl(sas)
    this.sasIsActive = false
    if (this.isCloud) {
      // Vue.prototype.$dms.getConfig(this.onGetConfig)
    }
    sas.checkIsAvailable(this.sasIsAvailable, this.onGetFailed)
    // sas.getS(this.onGetStatus)
    // sas.getClients(this.onGetClients, this.onGetFailed)

    // Vue.prototype.$dms.getStatus(this.onGetDMSStatus)
    // Vue.prototype.$dms.getStorageCategories(this.onGetCategories)
    this.reloadStatus()
    // Render the PayPal button into #paypal-button-container
    window.sasComponent = this
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .shopText {
    padding: 10px;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/Config.vue